import { FC, useContext, useState } from 'react';
import { Config, EditableComponent, MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { AccuWeatherProps } from './AccuWeather.types';
import { StyledAccuWeather } from './AccuWeather.styles';
import { statesConstant } from '../../modules/utils/constants/constants';
import { PageParamsContext } from '../../modules/context/PageContext';
import { AccuWeatherNearByThingsToDo } from './components/AccuWeatherNearByThingsToDo';
import { AccuWeatherHeader } from './components/AccuWeatherHeader';
import { AccuWeatherData } from './data/AccuWeatherData';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const AccuWeather: FC<AccuWeatherProps> = pageProps => {
  const { selectPositioning, isAuthorMode, showAccuWeatherInL1 = false } = pageProps;
  const [accuWeatherData, setAccuWeatherData] = useState(null);
  const { preProcessorResponse } = useContext(PageParamsContext);
  const { state = '' } = preProcessorResponse ?? {};

  return !(state === statesConstant.connect || state === statesConstant.preconnect) ? (
    <StyledAccuWeather data-testid="accuWeather" data-component-name="o-ppv5-accuWeather">
      {!accuWeatherData ? <AccuWeatherData isAuthorMode={isAuthorMode} setData={setAccuWeatherData} /> : null}
      {selectPositioning === 'headerAccuweather' ? (
        <AccuWeatherHeader {...pageProps} showAccuWeatherInL1={showAccuWeatherInL1} />
      ) : null}
      {selectPositioning === 'nearbyAccuweather' ? <AccuWeatherNearByThingsToDo {...pageProps} /> : null}
    </StyledAccuWeather>
  ) : null;
};

export const AccuWeatherConfig = {
  emptyLabel: 'AccuWeather',
  isEmpty: (_props: MappedComponentProperties) => false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/accuWeather`,
} as Config<MappedComponentProperties>;

export const AccuWeatherEditable = (props: AccuWeatherProps) => (
  <EditableComponent config={AccuWeatherConfig} {...props}>
    <AccuWeather {...props} />
  </EditableComponent>
);
